import { Component, OnInit } from '@angular/core';
import { Supplier } from '../../../../classes/Supplier';
import { GlobalService } from '../../../services/global.service';
import { LoginService } from '../../../services/login.service';
import { ModelService } from '../../../services/model.service';


@Component({
  selector: 'app-suppliers',
  templateUrl: './suppliers.component.html',
  styleUrls: ['./suppliers.component.scss']
})
export class SuppliersComponent implements OnInit {

  suppliersData: Supplier[] = [];
  contentVisible: boolean = false;

  availableRoles: string[] = [ 'admin', 'installer' ];
  isAvailable: boolean = true;

  constructor ( 
    private model: ModelService,
    private global: GlobalService,
    private loginService: LoginService ) {
    this.global.setDocumentTitle( 'Suppliers' );
    if ( this.availableRoles.indexOf( this.loginService.userInfo.role ) === -1 ) this.isAvailable = false;
    else this.isAvailable = true;
  }

  ngOnInit ( ) {
    this.model.getSuppliersData( ( spData ) => {
      this.contentVisible = true;
      this.suppliersData = spData;
    });
  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/suppliers/suppliers/suppliers.component.ts